<template>
  <div id="app">
    <el-container>
      <el-header class="div-header">
        <Header />
        <el-divider class="header-divider"></el-divider>
      </el-header>
      <div class="main-div">
        <el-container class="main-div parentDiv">
          <splitpanes class="default-theme defaultStyle custom-splite">
            <pane size="100" class="SideBarLeft">
				<prime />
              <!--SID1038 Body Part -->

              <template>
                <el-dialog
                  title
                  :visible.sync="dialogVisible "
                  :show-close="true"
                  :close-on-click-modal="false"
                  class="SID0003_Container"
                >
                  <el-container class="SID0003__emailsecurity">
                    <div class="SID0003__Container">
                      <!-- Breadcrumb section -->
                      <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '0002' }">トップ</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: '' }">記事一覧</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: '' }">メール配信設定</el-breadcrumb-item>
                      </el-breadcrumb>
                      <!-- <div>
						<el-divider class="result-main-divider"></el-divider>
                      </div>-->
                      <el-container>
                        <el-form
                          ref="form"
                          :rules="rules"
                          :model="form"
                          class="div-form formMailVaidate"
                          label-width="auto"
                        >
                          <el-form-item label="設定対象テーマ" class="label-emailform0003">
                            <span id="label-left-align">{{setMailTheme}}</span>
                          </el-form-item>
                            <el-form-item label="媒体" class="emailform0003" prop="medium">
                            <el-checkbox-group v-model="form.medium">
                              <el-checkbox label='101'  class="checkbox0003">新聞</el-checkbox>
                              <el-checkbox label="3" name="type" class="checkbox0003">WEB</el-checkbox>
                              <el-checkbox label="5" name="type" >雑誌/WEB</el-checkbox>
                            </el-checkbox-group>
                          </el-form-item>
                          <el-form-item label="配信先メールアドレス" class="emailform0003" prop="input1">
                            <el-input v-model="form.input1"></el-input>
                          </el-form-item>
                          <el-form-item label="配信先メールアドレス(確認用)" class="emailform0003" prop="input2">
                            <el-input v-model="form.input2"></el-input>
                          </el-form-item>
                          <span class="emailsecurity0003">メール配信停止をご希望の方は、本サービスの管理者に連絡してください。</span>
                          <el-row class="ButtonDiv">
                            <!-- 2021/08/02  #11641  START -->
                            <el-button type="primary" plain @click="open('form')" :disabled="Buttonpressed == 1">登録</el-button>
                            <!-- 2021/08/02  #11641  END -->
                            <el-button type="info" plain @click="gototop()">戻る</el-button>
                            <!-- <span class="buttonSpan">{{ text }}</span>  -->
                          </el-row>
                        </el-form>
                      </el-container>

                      <el-row class="ButtonSubmit" v-if="TableVisible">
                        <el-button @click="tableClick" type="primary" plain>送信</el-button>
                      </el-row>
                      <el-container v-if="TableVisible">
                        <el-table
                          ref="multipleTable"
                          :data="getTableResult1002"
                          border
                          style="width: 100%"
                        >
                          <el-table-column type="selection"></el-table-column>
                          <el-table-column property="media" label="媒体" show-overflow-tooltip="true"></el-table-column>
                          <el-table-column
                            property="mailaddres"
                            label="メールアドレス"
                            show-overflow-tooltip="false"
                          ></el-table-column>
                          <el-table-column
                            property="themename"
                            label="テーマ名"
                            show-overflow-tooltip="false"
                          ></el-table-column>
                          <el-table-column
                            property="template"
                            label="テンプレート"
                            show-overflow-tooltip="false"
                          ></el-table-column>
                        </el-table>
                      </el-container>
                      <el-row class="ButtonSubmit" v-if="TableVisible">
                        <el-button @click="tableClick" type="primary" plain>送信</el-button>
                        <!-- <span class="buttonSpan">{{ dummy }}</span> -->
                      </el-row>
                    </div>
                  </el-container>
                </el-dialog>
              </template>

              <!--SID1038 Body Part End-->
            </pane>
            <pane class="SideBarRight">
              <SideBar class="SidePane" />
            </pane>
          </splitpanes>
        </el-container>
      </div>
      <el-container class="footer-div">
        <el-footer class="footer-element">
          <FooterComponent />
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Header from "../common/header.vue";
import prime from '../top_page/mainComponent.vue';
import SideBar from "../common/side-bar.vue";
import FooterComponent from "../common/footerComponent.vue";
import { mapGetters } from "vuex";
import router from "../../router";
import json from "../../components/config.json";
//import Common from '../../common/CommonFunc.js'
// In your VueJS component.
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";

export default {
  name: "app",
  components: {
	Header,
	prime,
    SideBar,
    FooterComponent,
    Splitpanes,
    Pane
  },
  data() {
    var checksymbolandFullWidth = (Rules, value, callback) => {
        //var sympattern=/[^-!$%^&*()_+|~=`{}[\]:";'<>?,.@#/]$/gi;
        //var sympattern= /^[a-zA-Z0-9]+$/
        var sympattern= /^[+\u3040-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\uff66-\uff9fa-zA-Z0-9@.-_]+$/
        console.log("Checksymbol"+value)
        var chksym= value;
        var flag=1;
        var i;
        for(i=0; i<chksym.length; i++) {
            var c = chksym[i].charCodeAt(0);
            if (c >= 0xFF00 && c <= 0xFFEF) {
               flag = 0;
            }
         }
         if(flag == 0){
            callback(new Error("メールアドレスは半角英数字を入力してください。"));
        }
       else if (!chksym.match(sympattern)) {
             
                 callback(new Error('メールアドレスに使用できない文字が含まれています。'));
             }
         else{
             callback();
         }
     };
    // var checkEmail = (rule, value, callback) => {
    //   var emailREG = /^[+\u3040-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\uff66-\uff9fa-zA-Z0-9@.-_]+$/;
    //   // alert(value.length);
    //   if (!value.match(emailREG)) {
    //     callback(new Error("ENTER VALID EMAILIID"));
    //   } else {
    //     callback();
    //   }
    // };
    var confirmEmail = (rule, value, callback) => {
      var emailConfirm = this.form.input1;
              var sympattern= /^[+\u3040-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\uff66-\uff9fa-zA-Z0-9@.-_]+$/
        console.log("Checksymbol"+value)
        var chksym= value;
        var flag=1;
        var i;
        for(i=0; i<chksym.length; i++) {
            var c = chksym[i].charCodeAt(0);
            if (c >= 0xFF00 && c <= 0xFFEF) {
               flag = 0;
            }
         }if(flag == 0){
            callback(new Error("メールアドレスは半角英数字を入力してください。"));
        }
       else if (!chksym.match(sympattern)) {
             
                 callback(new Error('メールアドレスに使用できない文字が含まれています。'));
             }
      //  alert(emailConfirm);
        else if (value != emailConfirm) {
        callback(new Error("メールアドレスがメールアドレス（確認用）と一致しないので、再入力してください。"));
      } 
    };
    return {
      form: {
        input1: "",
        input2: "",
        medium:[]
      },
      // 2021/08/02  #11641  START
      Buttonpressed: 0,
      // 2021/08/02  #11641  END
      dummy: "",
      text: "",
      dialogVisible: true,
      setMailTheme: '',
      type: [],
      name: "",
      TableVisible: false,
      value1: true,
      value2: true,
      value3: true,
      value4: true,
      dateoptions: [
        {
          value: "2016/09/26",
          label: "2016/09/26"
        },
        {
          value: "2016/09/27",
          label: "2016/09/27"
        },
        {
          value: "2017/09/27",
          label: "2017/09/27"
        },
        {
          value: "2017/09/26",
          label: "2017/09/26"
        },
        {
          value: "2018/09/27",
          label: "2017/09/27"
        },
        {
          value: "2018/09/26",
          label: "2017/09/26"
        },
        {
          value: "2016/09/23",
          label: "2016/09/23"
        }
      ],
      datevalue: "2016/09/23",
      themeoptions: [
        {
          value: "すべて",
          label: "すべて"
        },
        {
          value: "自社関連",
          label: "自社関連"
        },
        {
          value: "テーマグループG",
          label: "テーマグループG"
        },
        {
          value: "トピックス",
          label: "トピックス"
        }
      ],
      themevalue: "すべて",
      mediaoptions: [
        {
          value: "新聞",
          label: "新聞"
        },
        {
          value: "WEB",
          label: "WEB"
        }
      ],
      mediavalue: "新聞",
      addressoptions: [
        {
          value: "xxx＠exmaple.com",
          label: "xxx＠exmaple.com"
        }
      ],
      addressvalue: "xxx＠exmaple.com",
      multipleSelection: [],
      rules: {
        input1: [
          {
            required: true,
            type: "string",
            message: "配信先メールアドレスを入力してください。"
          },
          {
            validator: checksymbolandFullWidth,
            trigger: "blur"
          },
          { type: 'email', message: '有効なメールアドレスを入力してください', trigger: 'blur' },
          { max:256, message: 'メールアドレスは256文字以下を入力してください。', trigger: 'change' }
        ],
        input2: [
          {
            required: true,
            type: "string",
            message: "配信先メールアドレス(確認用)を入力してください。"
          },
           { type: 'email', message: '有効なメールアドレスを入力してください', trigger: 'blur' },
          { max:256, message: 'メールアドレスは256文字以下を入力してください。', trigger: 'change' },
          {
            validator: confirmEmail,trigger: "blur"
          },
        ],
        medium: [
          {
            required:true,
            message:'媒体が1つ以上を選択してください。',
            trigger:'blur'
          }
        ]
      }
    };
  },

  computed: {
    ...mapGetters("situation0003", [
      "getTableResult0003",
      "getdateoptions",
      "getdatevalue",
      "getthemeoptions",
      "getthemevalue",
      "getmediaoptions",
      "getmediavalue",
      "getaddressoptions",
      "getaddressvalue",
      "getStatus"
    ])
  },
  mounted(){
    var theme_value = this.$route.query.themeValue;
    console.log(theme_value)
    this.setMailTheme = theme_value
  },
  methods: {
    gototop() {
     this.dialogVisible=false;
     // router.push({ name: "Home" });
    },
    // Email Address Validation
    open(formName) {
      console.log(this.form.medium);
       console.log(this.form.medium.length);
      // 2021/08/02  #11641  START
      this.Buttonpressed= 1;
      // 2021/08/02  #11641  END 
      this.$refs[formName].validate(valid => {
        if (valid) {
           
          var checkWebNews=[]
          if(this.form.medium.length==1){
            if(this.form.medium[0]==1){
             checkWebNews=[1,2]
           }else{
             checkWebNews=[3]
           }
          }else{
            checkWebNews=[1,2,3]
          }
          // if(this.form.medium[0]==1){
          //   checkWebNews=[1,2]
          // }else if(this.form.medium[0]==3){
          //   checkWebNews=[3]
          // }else{
          //   checkWebNews=[1,2,3]
          // }
          console.log(checkWebNews)
          
          var credentials = {
              
              theme_id:(this.$route.query.themeId).toString(),
              data_kbn:parseInt(this.$route.query.data_kbn),
              data_section:checkWebNews,
              mail_address:this.form.input1
              };
          console.log(credentials);
          this.$store.dispatch('communication0003/MailDelivery',credentials).then(() => {
             
            var status = this.getStatus;

              if(status == 0){
                    this.$alert(json["0003_send_success_message"], json["0003_send_success_title"], {
                      confirmButtonText: 'OK',
                    }).then(() => {
                      router.push({name:"Home"});
                    })
                  }else{
                    this.$alert(json["0003_send_failure_message"], json["0003_send_failure_title"], {
                      confirmButtonText: 'OK',
                    });
                  }
            // 2021/08/02  #11641  START
            this.Buttonpressed= 0;
            // 2021/08/02  #11641  END  
           })

        } else {
          // console.log('error submit!!');
          return false;
        }
      });

      //   this.text ="メールアドレスが登録されました。";
    }
  },
  beforeCreate(){
    //Common.Session.CheckSessionExists_IfExpired_GoToLogout();
  },
  tableClick() {
    this.dummy = "保存しました。";
  },
  created(){
    //For the screen Title
     document.title = "記事閲覧";
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "0003.css";
</style>